var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "text" } },
      [
        _vm._l(_vm.sceneList, function(c, key) {
          return _c("div", { key: key, staticClass: "step-list" }, [
            _c("div", { staticClass: "step-list_top" }, [
              _c("div", { staticClass: "list_top_left" }, [
                _c("div", {
                  staticClass: "circle",
                  class: c.status == "Finish" ? "circle" : "othercircle"
                }),
                _vm._v(
                  "\n                " + _vm._s(c.name) + "\n                "
                ),
                _c(
                  "div",
                  { class: c.status == "Finish" ? "isgreen" : "isred" },
                  [
                    _vm._v(
                      "\n                  " +
                        _vm._s(c.status == "Finish" ? "已完成" : "未完成") +
                        "\n                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "list_top_right" }, [
                _c(
                  "div",
                  { staticClass: "buttonx", on: { click: _vm.gocurriculum } },
                  [_vm._v("点击学习")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "step-list_under" }, [
              _vm._v(
                "\n              场景介绍：" +
                  _vm._s(c.description) +
                  "\n            "
              )
            ])
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06f669d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06f669d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/newservice/Scene.vue
// module id = 1638
// module chunks = 0